import React, { useState, useEffect } from 'react';
import '../CSS/compteur.css';
import { fetchAverage, fetchLastPoint } from '../FireBase/firebaseService'; // Import des services Firebase

function Compteur() {
  const [lastPoint, setLastPoint] = useState(null);
  const [angle, setAngle] = useState(0);
  const [position, setPosition] = useState({ x: '30%', y: '70%' });
  const [isDragging, setIsDragging] = useState(false);
  const [moyenneVitesse, setMoyenneVitesse] = useState(0);

  const [size] = useState(300); // Taille dynamique
  const collectionName = localStorage.getItem('collectionName') || '/data';

  useEffect(() => {
    const unsubscribe = fetchAverage(
      collectionName,
      'S',
      (average) => setMoyenneVitesse(average),
      (error) => console.error(error)
    );
    return () => unsubscribe();
  }, [collectionName]);

  useEffect(() => {
    const unsubscribe = fetchLastPoint(
      collectionName,
      (point) => setLastPoint(point),
      (error) => console.error(error)
    );
    return () => unsubscribe();
  }, [collectionName]);

  useEffect(() => {
    const validVitesse = lastPoint?.S ? Math.max(0, Math.min(lastPoint.S, 100)) : 0;
    const newAngle = (validVitesse / 100) * 180;

    const step = (newAngle - angle) / 10;
    let currentAngle = angle;
    const interval = setInterval(() => {
      currentAngle += step;
      if (Math.abs(currentAngle - newAngle) < Math.abs(step)) {
        clearInterval(interval);
        currentAngle = newAngle;
      }
      setAngle(currentAngle);
    }, 50);

    return () => clearInterval(interval);
  }, [lastPoint, angle]);

  const handleMouseDown = () => setIsDragging(true);
  const handleMouseMove = (e) => {
    if (isDragging) {
      setPosition({
        x: e.clientX - size / 2,
        y: e.clientY - size / 4,
      });
    }
  };
  const handleMouseUp = () => setIsDragging(false);

  return (
    <div>
      <div
        style={{ position: 'absolute', left: position.x, top: position.y }}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
      >
        <div className="compteur-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div
            className="compteur-box"
            onMouseDown={handleMouseDown}
            style={{
              width: `${size}px`,
              height: `${size / 2}px`,
              position: 'relative',
              cursor: 'grab',
            }}
          >
            {lastPoint ? (
              <div>
                <svg
                  style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: `${size}px`,
                    height: `${size / 2}px`,
                  }}
                >
                  <circle cx={size / 2} cy={size / 2} r="5" fill="#000" />
                  <line
                    x1={size / 2}
                    y1={size / 2}
                    x2={size / 2 + (size / 3) * Math.cos((angle - 180) * (Math.PI / 180))}
                    y2={size / 2 + (size / 3) * Math.sin((angle - 180) * (Math.PI / 180))}
                    stroke="#FF0000"
                    strokeWidth="3"
                  />
                </svg>
                <svg
                  style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: `${size}px`,
                    height: `${size / 2}px`,
                  }}
                >
                  {[...Array(11).keys()].map((i) => {
                    const gradAngle = (i / 10) * 180 - 180;
                    const x1 = size / 2 + (size / 3.3) * Math.cos((gradAngle) * (Math.PI / 180));
                    const y1 = size / 2 + (size / 3.3) * Math.sin((gradAngle) * (Math.PI / 180));
                    const x2 = size / 2 + (size / 3) * Math.cos((gradAngle) * (Math.PI / 180));
                    const y2 = size / 2 + (size / 3) * Math.sin((gradAngle) * (Math.PI / 180));
                    return (
                      <React.Fragment key={i}>
                        <line
                          x1={x1}
                          y1={y1}
                          x2={x2}
                          y2={y2}
                          stroke="#000"
                          strokeWidth={i % 5 === 0 ? 2 : 1}
                        />
                        {(i * 10 !== 0 && i * 10 !== 100) && (
                          <text
                            x={x2 + 15}
                            y={y2 + 5}
                            fontSize="12"
                            fill="#666"
                            alignmentBaseline="middle"
                            textAnchor="middle"
                            transform={`rotate(${gradAngle}, ${x2}, ${y2})`}
                          >
                            {i * 10}
                          </text>
                        )}
                      </React.Fragment>
                    );
                  })}
                </svg>
              </div>
            ) : (
              <p>Chargement...</p>
            )}
          </div>

          {lastPoint && (
            <p className="vitesse" style={{ fontSize: '1.2rem', fontWeight: 'bold', marginTop: '10px' }}>
              Vitesse: {lastPoint.S}
            </p>
          )}
          <p>Moyenne Générale: {moyenneVitesse.toFixed(2)}</p>
        </div>
      </div>
    </div>
  );
}

export default Compteur;
